import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from '@/components/ui/sidebar'
import { useLocation, useNavigate } from 'react-router-dom'
import Icon from './icon'
import { Separator } from './ui/separator'
import { cn } from '@/lib/utils'
import { useQueryClient } from '@tanstack/react-query'
import { getPlanFeatureSettingsPlanFeatureSettingsGetQueryKey } from '@/generated/@tanstack/react-query.gen'

const navItems = [
  {
    title: 'User List',
    url: '/enterprise/user',
    iconName: 'user-friends',
    // isActive: true,
  },
  {
    title: 'Payments',
    url: '/enterprise/payments',
    iconName: 'credit-card',
  },

  {
    title: 'Billing History',
    url: '/enterprise/billing-history',
    iconName: 'receipt',
  },
]

export function NavMain() {
  const { open, isMobile, openMobile } = useSidebar()

  return isMobile && openMobile ? (
    <SideBarExpanded />
  ) : open ? (
    <SideBarExpanded />
  ) : (
    <SideBarCollapse />
  )
}

const SideBarCollapse = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  return (
    <SidebarGroup>
      <SidebarMenu>
        {navItems.map((item) => {
          const isActive = location.pathname === item.url
          return (
            <SidebarMenuItem key={item.url} className="py-2">
              <SidebarMenuButton
                className="h-[50px] w-full rounded-none relative"
                onClick={() => navigate(item.url)}
                tooltip={item.title}
              >
                <div
                  className={cn('w-[7px] h-full rounded-r-md', {
                    'bg-primary': isActive,
                  })}
                />
                <div className="w-full flex items-center justify-center absolute left-0 top-0 h-full">
                  <Icon
                    className={cn('', {
                      'text-primary': isActive,
                    })}
                    name={item.iconName}
                    size="24px"
                  />
                </div>
              </SidebarMenuButton>
            </SidebarMenuItem>
          )
        })}
        <SidebarMenuItem>
          <SidebarMenuButton
            className="h-[50px] flex flex-row justify-center items-center"
            onClick={() => {
              localStorage.setItem('auth', JSON.stringify({}))
              queryClient.resetQueries({
                queryKey:
                  getPlanFeatureSettingsPlanFeatureSettingsGetQueryKey(),
              })
              window.location.replace('/sign-in')
            }}
            tooltip={'Logout'}
          >
            <Icon name={'power-off'} size="24px" />
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  )
}

const SideBarExpanded = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  return (
    <SidebarGroup>
      <SidebarMenu>
        {navItems.map((item) => {
          const isActive = location.pathname === item.url
          return (
            <SidebarMenuItem key={item.url} className="py-2">
              <SidebarMenuButton
                className="h-[50px] flex flex-row space-x-3 rounded-none !p-0 !pr-5"
                onClick={() => navigate(item.url)}
                tooltip={item.title}
              >
                <div
                  className={cn(
                    'w-[7px] h-full !rounded-l-none !rounded-r-md',
                    {
                      'bg-primary': isActive,
                    }
                  )}
                />
                <div
                  className={cn('w-full h-full rounded-lg', {
                    'bg-primary text-white': isActive,
                  })}
                >
                  <div className="flex flex-row h-full px-4 items-center gap-4">
                    <Icon name={item.iconName} size="24px" />
                    <p className="text-sm font-semibold truncate">
                      {item.title}
                    </p>
                  </div>
                </div>
              </SidebarMenuButton>
            </SidebarMenuItem>
          )
        })}

        <Separator />

        <SidebarMenuItem>
          <SidebarMenuButton
            onClick={() => {
              localStorage.removeItem('auth')
              queryClient.resetQueries({
                queryKey:
                  getPlanFeatureSettingsPlanFeatureSettingsGetQueryKey(),
              })
              window.location.replace('/sign-in')
            }}
            className={cn('h-[50px]', 'flex flex-row space-x-3 !p-0 !pr-5')}
            tooltip={'Logout'}
          >
            <div className={'w-[7px] h-full rounded-tr-sm rounded-br-sm'} />
            <div className={`w-full h-full rounded-sm`}>
              <div className="flex flex-row h-full items-center px-4 gap-4">
                <Icon name={'power-off'} size="24px" />
                <p className="text-sm font-semibold">{'Logout'}</p>
              </div>
            </div>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  )
}
